import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ColorSwatch from '@stone/components/product/ColorSwatch';
import SwiperCore, { A11y, Controller, EffectCoverflow, Keyboard } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import SelectorColor from '@common/ui/selector/SelectorColor';
SwiperCore.use([A11y, Keyboard, Controller, EffectCoverflow]);
const ProductSelectionColorPDP = (props) => {
    const { t } = useTranslation();
    // const [isKeyboardIntent, setIsKeyboardIntent] = useState(false);
    const { isWideDesktop } = useMediaQueries();
    const swiperRef = useRef();
    const slideMove = (swiper) => {
        const prevs = document.querySelectorAll('.selector-prev-pdpcolor');
        prevs.forEach((prev) => {
            if (swiper.isBeginning) {
                prev === null || prev === void 0 ? void 0 : prev.setAttribute('disabled', 'disabled');
                prev === null || prev === void 0 ? void 0 : prev.classList.add('swiper-button-disabled');
            }
            else {
                prev === null || prev === void 0 ? void 0 : prev.removeAttribute('disabled');
                prev === null || prev === void 0 ? void 0 : prev.classList.remove('swiper-button-disabled');
            }
        });
        const nexts = document.querySelectorAll('.selector-next-pdpcolor');
        nexts.forEach((next) => {
            if (swiper.isEnd) {
                next === null || next === void 0 ? void 0 : next.setAttribute('disabled', 'disabled');
                next === null || next === void 0 ? void 0 : next.classList.add('swiper-button-disabled');
            }
            else {
                next === null || next === void 0 ? void 0 : next.removeAttribute('disabled');
                next === null || next === void 0 ? void 0 : next.classList.remove('swiper-button-disabled');
            }
        });
    };
    /* EFFECT */
    const swiperConf = {
        a11y: {
            slideRole: null,
            slideLabelMessage: null,
        },
        // navigation: true,
        slideToClickedSlide: false,
        slidesPerView: 4,
        spaceBetween: -2,
        autoplay: false,
        threshold: 5,
        // slideToClickedSlide: true,
        // centeredSlides: true,
        breakpoints: {
            [window.mqObj.lg]: {
                slidesPerView: 5,
                spaceBetween: 0, //adjust overflow for accessibility, from css is 6px (3px margin for side)
            },
        },
        onSlideChange: slideMove,
        onInit: (swiper) => {
            slideMove(swiper);
            const prevs = document.querySelectorAll('.selector-prev-pdpcolor');
            const nexts = document.querySelectorAll('.selector-next-pdpcolor');
            const prevHandler = (e) => {
                e.preventDefault();
                swiperRef.current.slidePrev();
            };
            const nextHandler = (e) => {
                e.preventDefault();
                swiperRef.current.slideNext();
            };
            console.log('ADD HANDLER');
            prevs.forEach((prev) => prev === null || prev === void 0 ? void 0 : prev.addEventListener('click', prevHandler));
            nexts.forEach((next) => next === null || next === void 0 ? void 0 : next.addEventListener('click', nextHandler));
        },
    };
    const startingSlideIndex = useMemo(() => {
        var _a;
        return (_a = props.variationValues) === null || _a === void 0 ? void 0 : _a.findIndex((el) => el.id === props.currentId);
    }, [props.variationValues, props.currentId]);
    // useEffect(() => {
    //   let keboardHandler = (data: { isKeyboardMode: boolean }) => {
    //     setIsKeyboardIntent(data.isKeyboardMode);
    //   };
    //   customEventBus.on('keyboard:mode', keboardHandler);
    //   return () => {
    //     customEventBus.off('keyboard:mode', keboardHandler);
    //   };
    // }, []);
    const renderColorSwatch = (variation) => (React.createElement(SelectorColor, { key: variation.id, value: variation.id, label: variation.displayValue, disabled: props.alwaysAvailable ? false : !variation.selectable && !window.unshoppable && !props.boutiqueAvailability, selected: variation.value == props.currentId, isOutOfStock: variation.selectable, item: variation, onSelect: (variation) => {
            props.onChangeVariation(variation);
        }, productUuid: props.productUuid, isNotAvailableSelectable: props.isNotAvailableSelectable, isBoutiqueExclusive: props.isBoutiqueExclusive },
        React.createElement(ColorSwatch, { variation: variation, ariaHidden: true }),
        !props.boutiqueAvailability && React.createElement("span", { className: "stroke" })));
    const printColorsCarousel = () => startingSlideIndex !== null &&
        startingSlideIndex >= 0 && (React.createElement(SwiperInstance, Object.assign({ onSwiper: (swiper) => {
            swiperRef.current = swiper;
        }, initialSlide: startingSlideIndex }, swiperConf), props.variationValues.map((variation, i) => (React.createElement(SwiperSlide, { "aria-label": null, key: i }, renderColorSwatch(variation))))));
    const printColorsGrid = () => React.createElement("div", { className: "selector__menu--grid" }, props.variationValues.map((variation, i) => renderColorSwatch(variation)));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "selector-color inpdp" },
            React.createElement("fieldset", { className: "selector__menu", id: "pdp-colorSelector" },
                React.createElement("legend", { className: "visually-hidden" }, t('label.selectacolor')),
                isWideDesktop ? printColorsGrid() : printColorsCarousel()),
            React.createElement("div", { tabIndex: -1, "aria-hidden": "true", style: {
                    visibility: 'hidden',
                    position: 'absolute',
                    height: 0,
                    width: 0,
                    padding: 0,
                } }, props.variationValues.map((variation) => (React.createElement("a", { key: variation.id, "aria-current": variation.value == props.currentId ? 'page' : undefined, href: window.origin + variation.productUrl }, variation.displayValue)))))));
};
ProductSelectionColorPDP.defaultProps = {
    variationValues: [],
    dropdown: false,
};
export default ProductSelectionColorPDP;
